import { func_validation } from 'functions';
import { userManagementConstants } from '../constants';

export function userManagementReducers(state = {}, action) {
    const { 
        totalRequests = 0,
        collectiveErrorMsg = ""
    } = state;

    let collectiveErrorMsg_formatted = collectiveErrorMsg;

    switch (action.type) {
            
        // Get User List
        
        case userManagementConstants.getUserList_request:
            return {
                ...state,
                getUserList_requesting: true, getUserList_status: false,
            }
        case userManagementConstants.getUserList_success:
            return {
                ...state,
                getUserList_requesting: false, getUserList_status: true,
                userList: action.details.data,
                userListHeaders: action.details.headers,
            }
        case userManagementConstants.getUserList_failure:
            return {
                ...state,
                getUserList_requesting: false, getUserList_status: false,
            }


        // Get User Group List

        case userManagementConstants.getUserGroupList_request:
            return {
                ...state,
                getUserGroupList_requesting: true, getUserGroupList_status: false,
            }
        case userManagementConstants.getUserGroupList_success:
            return {
                ...state,
                getUserGroupList_requesting: false, getUserGroupList_status: true,
                userGroupList: action.details.data,
                userGroupListHeaders: action.details.headers,
            }
        case userManagementConstants.getUserGroupList_failure:
            return {
                ...state,
                getUserGroupList_requesting: false, getUserGroupList_status: false,
            }

        // Get User Group Permission List

        case userManagementConstants.getUserGroupPermissionList_request:
            return {
                ...state,
                getUserGroupPermissionList_requesting: true, getUserGroupPermissionList_status: false,
            }
        case userManagementConstants.getUserGroupPermissionList_success:
            let userGroupPermissionList = action.details.data;
            let userGroupPermissionList_formatted = [];
            if (func_validation.isArrayNotEmpty(userGroupPermissionList)) {
                // Separate permissions into objects
                let permissionListObj = {};
                userGroupPermissionList.map((permissions, idx) => {
                    let permissionsList = permissions.split("_");
                    if (permissionsList.length == 3) {
                        let role = permissionsList[0];
                        let userGroupPermission = permissionsList[1];
                        let permission = permissionsList[2];

                        // Find role
                        if (!permissionListObj[role]) {
                            permissionListObj[role] = {};
                        }

                        // Find user group permission
                        if (!permissionListObj[role][userGroupPermission]) {
                            permissionListObj[role][userGroupPermission] = {};
                        }

                        // Find permission
                        if (!permissionListObj[role][userGroupPermission][permission]) {
                            permissionListObj[role][userGroupPermission][permission] = {
                                original: permissions
                            };
                        }
                    }                
                });

                // Convert role object to array of objects
                for (const role in permissionListObj) {
                    if (permissionListObj.hasOwnProperty(role)) {
                        userGroupPermissionList_formatted.push({
                            "Role": role,
                            "UserGroupPermissionList": []
                        });
                        
                        // Convert user group permission object to array of objects
                        const roleObj = permissionListObj[role];
                        let roleArrayIndex = userGroupPermissionList_formatted.length - 1;
                        let userGroupPermissionList = userGroupPermissionList_formatted[roleArrayIndex].UserGroupPermissionList;
                        for (const userGroupPermission in roleObj) {
                            if (roleObj.hasOwnProperty(userGroupPermission)) {
                                userGroupPermissionList.push({
                                    "UserGroupPermission": userGroupPermission,
                                    "PermissionList": []
                                });
                                
                                // Store permission into array
                                const userGroupPermissionObj = roleObj[userGroupPermission];
                                let userGroupPermissionArrayIndex = userGroupPermissionList.length - 1;
                                let permissionList = userGroupPermissionList[userGroupPermissionArrayIndex].PermissionList;
                                for (const permission in userGroupPermissionObj) {
                                    if (userGroupPermissionObj.hasOwnProperty(permission)) {
                                        permissionList.push({
                                            "Permission": permission,
                                            "Original": userGroupPermissionObj[permission].original
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return {
                ...state,
                getUserGroupPermissionList_requesting: false, getUserGroupPermissionList_status: true,
                userGroupPermissionList: userGroupPermissionList_formatted,
                userGroupPermissionListHeader: action.details.headers
            }
        case userManagementConstants.getUserGroupPermissionList_failure:
            return {
                ...state,
                getUserGroupPermissionList_requesting: false, getUserGroupPermissionList_status: false,
            }

        // Get User Group Permission

        case userManagementConstants.getUserGroupPermission_request:
            return {
                ...state,
                getUserGroupPermission_requesting: true, getUserGroupPermission_status: false,
            }
        case userManagementConstants.getUserGroupPermission_success:
            // Turn array into object for faster access to permissions
            let userPermissions = {};
            let responseData = action.details.data;
            if (func_validation.isArrayNotEmpty(responseData)) {
                responseData.map((data) => {
                    if (func_validation.isStringTrimNotEmpty(data)) {
                        userPermissions[data] = true;
                    }
                })
            }

            return {
                ...state,
                getUserGroupPermission_requesting: false, getUserGroupPermission_status: true,
                userPermissions: userPermissions,
            }
        case userManagementConstants.getUserGroupPermission_failure:
            return {
                ...state,
                getUserGroupPermission_requesting: false, getUserGroupPermission_status: false,
            }

        // Add User
        
        case userManagementConstants.addUser_request:
            return {
                ...state,
                addUser_requesting: true, addUser_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                addUser_errorMsg: undefined
            }
        case userManagementConstants.addUser_success:
            return {
                ...state,
                addUser_requesting: false, addUser_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.addUser_failure:
            return {
                ...state,
                addUser_requesting: false, addUser_status: false,
                isUserRecordUpdatedSuccessfully: false,
                addUser_errorMsg: action?.error?.response?.data?.exceptionMessage
            }


        // Update User
        
        case userManagementConstants.updateUser_request:
            return {
                ...state,
                updateUser_requesting: true, updateUser_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                updateUser_errorMsg: undefined
            }
        case userManagementConstants.updateUser_success:
            return {
                ...state,
                updateUser_requesting: false, updateUser_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.updateUser_failure:
            return {
                ...state,
                updateUser_requesting: false, updateUser_status: false,
                isUserRecordUpdatedSuccessfully: false,
                updateUser_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Delete User
        
        case userManagementConstants.deleteUser_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                deleteUser_requesting: true, deleteUser_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                deleteUser_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case userManagementConstants.deleteUser_success:
            return {
                ...state,
                deleteUser_requesting: (totalRequests > 1), deleteUser_status: true,
                isUserRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case userManagementConstants.deleteUser_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                deleteUser_requesting: (totalRequests > 1), deleteUser_status: false, 
                isUserRecordUpdatedSuccessfully: false,
                deleteUser_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Add User Group

        case userManagementConstants.addUserGroup_request:
            return {
                ...state,
                addUserGroup_requesting: true, addUserGroup_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                addUserGroup_errorMsg: undefined
            }
        case userManagementConstants.addUserGroup_success:
            return {
                ...state,
                addUserGroup_requesting: false, addUserGroup_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.addUserGroup_failure:
            return {
                ...state,
                addUserGroup_requesting: false, addUserGroup_status: false,
                isUserRecordUpdatedSuccessfully: false,
                addUserGroup_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Update User Group

        case userManagementConstants.updateUserGroup_request:
            return {
                ...state,
                updateUserGroup_requesting: true, updateUserGroup_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                updateUserGroup_errorMsg: undefined
            }
        case userManagementConstants.updateUserGroup_success:
            return {
                ...state,
                updateUserGroup_requesting: false, updateUserGroup_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.updateUserGroup_failure:
            return {
                ...state,
                updateUserGroup_requesting: false, updateUserGroup_status: false,
                isUserRecordUpdatedSuccessfully: false,
                updateUserGroup_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Delete User Group
        
        case userManagementConstants.deleteUserGroup_request:
            if (totalRequests == 0) 
            collectiveErrorMsg_formatted = "";

            return {
                ...state,
                deleteUserGroup_requesting: true, deleteUserGroup_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                deleteUserGroup_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case userManagementConstants.deleteUserGroup_success:
            return {
                ...state,
                deleteUserGroup_requesting: (totalRequests > 1), deleteUserGroup_status: true,
                isUserRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case userManagementConstants.deleteUserGroup_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                deleteUserGroup_requesting: (totalRequests > 1), deleteUserGroup_status: false, 
                isUserRecordUpdatedSuccessfully: false,
                deleteUserGroup_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Add User Group Mapping
        
        case userManagementConstants.addUserGroupMapping_request:
            return {
                ...state,
                addUserGroupMapping_requesting: true, addUserGroupMapping_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                addUserGroupMapping_errorMsg: undefined
            }
        case userManagementConstants.addUserGroupMapping_success:
            return {
                ...state,
                addUserGroupMapping_requesting: false, addUserGroupMapping_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.addUserGroupMapping_failure:
            return {
                ...state,
                addUserGroupMapping_requesting: false, addUserGroupMapping_status: false,
                isUserRecordUpdatedSuccessfully: false,
                addUserGroupMapping_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Delete User Group Mapping
        
        case userManagementConstants.removeUserGroupMapping_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                removeUserGroupMapping_requesting: true, removeUserGroupMapping_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                removeUserGroupMapping_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case userManagementConstants.removeUserGroupMapping_success:            
            return {
                ...state,
                removeUserGroupMapping_requesting: (totalRequests > 1), removeUserGroupMapping_status: true,
                isUserRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case userManagementConstants.removeUserGroupMapping_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                removeUserGroupMapping_requesting: (totalRequests > 1), removeUserGroupMapping_status: false, 
                isUserRecordUpdatedSuccessfully: false,
                removeUserGroupMapping_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Add Permission

        case userManagementConstants.addPermission_request:
            return {
                ...state,
                addPermission_requesting: true, addPermission_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                addPermission_errorMsg: undefined
            }
        case userManagementConstants.addPermission_success:
            return {
                ...state,
                addPermission_requesting: false, addPermission_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.addPermission_failure:
            return {
                ...state,
                addPermission_requesting: false, addPermission_status: false,
                isUserRecordUpdatedSuccessfully: false,
                addPermission_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Remove Permission

        case userManagementConstants.removePermission_request:
            return {
                ...state,
                removePermission_requesting: true, removePermission_status: false,
                isUserRecordUpdatedSuccessfully: undefined,
                removePermission_errorMsg: undefined
            }
        case userManagementConstants.removePermission_success:
            return {
                ...state,
                removePermission_requesting: false, removePermission_status: true,
                isUserRecordUpdatedSuccessfully: true
            }
        case userManagementConstants.removePermission_failure:
            return {
                ...state,
                removePermission_requesting: false, removePermission_status: false,
                isUserRecordUpdatedSuccessfully: false,
                removePermission_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        default:
            return state;
    }
}